import request from '@/util/request'
import store from '../store/store'

// 查询用户余额
export function queryuserbalance (data) {
  let token = store.getters.get_token
  return request({
    url: '/queryuserbalance',
    method: 'post',
    params: { token: token },
    data
  })
}
// 查询充值记录，需加上分页，做瀑布加载
export function queryuserorder (params, data) {
  params.token = store.getters.get_token
  return request({
    url: '/queryuserorder',
    method: 'post',
    params,
    data
  })
}
// 查询使用记录，需加上分页，做瀑布加载
export function querysmsvoicelog (params, data) {
  params.token = store.getters.get_token
  return request({
    url: '/querysmsvoicelog',
    method: 'post',
    params,
    data
  })
}
// 查询充值类型
export function queryuserordertype () {
  let token = store.getters.get_token
  return request({
    url: '/queryuserordertype',
    method: 'post',
    params: { token: token }
  })
}
// 微信充值
export function wechatorder (data) {
  let token = store.getters.get_token
  return request({
    url: '/wechatorder',
    method: 'post',
    params: { token: token },
    data
  })
}
// 查询订单是否成功
export function querywechatorderisok (data) {
  let token = store.getters.get_token
  return request({
    url: '/querywechatorderisok',
    method: 'post',
    params: { token: token },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/pay.js